import { FINANCIAL_PLAN_TYPE_DEFAULT } from '@/enums/financialPlanType.enum';

/**
 * Schema filtrów planu finansowego
 * @type {*}
 */
export const financialPlanFiltersSchema = {
  properties: {
    planType: {
      default: FINANCIAL_PLAN_TYPE_DEFAULT,
      title: 'Typ planu',
      type: 'string'
    },

    startDate: {
      title: 'Początek zakresu dat',
      type: 'string'
    },

    endDate: {
      title: 'Koniec zakresu dat',
      type: 'string',
      validFunc: [
        'if ($methods.dateDiff($value, this.startDate).days < 0) {',
        '  return "Koniec zakresu dat nie może być wcześniejszy, niż początek.";',
        '}',
        'return true;'
      ]
    },

    isUkraine: {
      default: null,
      title: 'Wniosek UA',
      type: 'boolean'
    }
  },

  title: 'Filtry planu',
  type: 'object'
};
